import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose, withApollo } from 'react-apollo';
import { withRouter } from 'react-router';
import AssignItem from 'legacy-src/components/assessment/AssignItem';
import { QUESTION_TYPES } from 'chameleon-src/constants/assignment';
import useQuizData from './useQuizData';
import useQuizTitle from './useQuizTitle';
import sendTelemetryEvent from './sendTelemetryEvent';
import AssignButton from './AssignButton';
import SingleAssign from './SingleAssign';
import AssignByType from './AssignByType';

export const CreateAndAssignAction = (props) => {
  const {
    userData,
    subjectData,
    client,
    items,
    subunitTitle,
    routes,
    unitNumber,
    params,
    subunitNumber,
    useNewAssignModalFlag,
  } = props;
  const { me, isAdmin, isCoordinator, chosenEducationPeriodCode } = userData;
  const isAdminOrCoordinator = isAdmin || isCoordinator;
  const [showCreateOption, setShowCreateOption] = useState(true);
  const [selectedType, setSelectedType] = useState('all');
  const [itemId, setItemId] = useState(null);
  const buttonRef = useRef();
  const { subject } = params;
  const createCallback = (quizId) => {
    setShowCreateOption(false);
    setItemId(quizId);
  };
  const deleteCallback = () => {
    setShowCreateOption(true);
    setItemId(null);
  };
  const { getTitleByType } = useQuizTitle(subject, unitNumber, subunitTitle);
  const { quizzes, createQuiz, deleteQuiz, onAssignQuiz } = useQuizData(
    items,
    client,
    selectedType,
    subject,
    unitNumber,
    subunitNumber,
    chosenEducationPeriodCode,
    createCallback,
    deleteCallback,
  );
  const hasOptions = new Set(items.map((i) => i.type)).size > 1;

  useEffect(() => {
    if (!showCreateOption && itemId && buttonRef.current) {
      buttonRef.current.click();
    }
  }, [itemId, showCreateOption]);

  const onCreateQuizPopoverClick = (isOpen) => {
    if (isOpen) {
      const quizTitle = getTitleByType();
      createQuiz(items, quizTitle, selectedType);
    }
  };

  const onAssignTypeClick = (type = 'all') => {
    if (!quizzes[type].id) {
      let filteredItems;

      if ([QUESTION_TYPES.mcq, QUESTION_TYPES.frq].includes(type)) {
        filteredItems = items.filter((item) => item.type === type);
      } else {
        filteredItems = [...items];
      }

      const quizTitle = getTitleByType(type);
      createQuiz(filteredItems, quizTitle, type);
    } else {
      setShowCreateOption(false);
    }

    setSelectedType(type);
  };

  const onAssign = (assignmentsResponse, totalAssignees) => {
    const assignmentsNumber = useNewAssignModalFlag
      ? assignmentsResponse.assignments.length
      : totalAssignees.length;
    sendTelemetryEvent(
      subject,
      selectedType,
      itemId,
      getTitleByType(selectedType),
      assignmentsNumber,
    );

    if (hasOptions) {
      setShowCreateOption(true);
    }

    onAssignQuiz && onAssignQuiz();
  };

  if (showCreateOption) {
    if (hasOptions) {
      return <AssignByType onClick={onAssignTypeClick} />;
    }

    return <SingleAssign onClick={onCreateQuizPopoverClick} />;
  }

  return (
    <AssignItem
      role="button"
      onAssignRedirect={false}
      isAdminOrCoordinator={isAdminOrCoordinator}
      scrambleable={false}
      me={me}
      subjectInfo={subjectData}
      itemId={itemId}
      itemTitle={getTitleByType(selectedType)}
      quizHasNonSecureQns={false}
      onClose={deleteQuiz}
      ariaLabel="Assign all to quiz"
      button={<AssignButton isDropdownButton={hasOptions} />}
      buttonRef={buttonRef}
      routes={routes}
      onAssign={onAssign}
    />
  );
};

CreateAndAssignAction.propTypes = {
  items: PropTypes.array,
  subunitTitle: PropTypes.string,
  unitNumber: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    .isRequired,
  subunitNumber: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    .isRequired,
};

CreateAndAssignAction.defaultProps = {
  items: [],
  subunitTitle: '',
};

const mapStateToProps = ({ userData, subject, userSubjects, featureFlag }) => ({
  userData,
  subjectData: subject.data,
  userSubjects,
  useNewAssignModalFlag: featureFlag.new_assign_modal,
});
export default compose(
  withApollo,
  withRouter,
  connect(mapStateToProps),
)(CreateAndAssignAction);
